module.exports = __webpack_public_path__ + "97d01a032a5ff44ea4c6a763bf6aed86.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TL.svg
// module id = 6XHY
// module chunks = 0